import { useState } from 'react';
import { Link } from "react-router-dom";
import Nav from 'react-bootstrap/Nav';

export default function MainNav () {
  const [currentPage, setCurrentPage] = useState('overview');
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <Nav className="justify-content-center mb-3" activeKey="/">
      {/* <Nav.Item>
        <Nav.Link 
          as={Link}
          to="/" 
          onClick={() => handlePageChange('overview')}
          active={currentPage == 'overview'}
        >
          Overview
        </Nav.Link>
      </Nav.Item> */}
      <Nav.Item>
        <Nav.Link 
          as={Link}
          to="/events" 
          onClick={() => handlePageChange('events')}
          active={currentPage == 'events'}
        >
          Events
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link 
          as={Link}
          to="/attendees" 
          onClick={() => handlePageChange('attendees')}
          active={currentPage == 'attendees'}
        >
          Attendees
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link 
          as={Link}
          to="/sales" 
          onClick={() => handlePageChange('sales')}
          active={currentPage == 'sales'}
        >
          Sales
        </Nav.Link>
      </Nav.Item>
      {/*
      <Nav.Item>
        <Nav.Link 
          as={Link}
          to="/team" 
          onClick={() => handlePageChange('team')}
          active={currentPage == 'team'}
        >
          Team
        </Nav.Link>
      </Nav.Item>
      */}
      {/*
      <Nav.Item>
        <Nav.Link 
          as={Link}
          to="/finance" 
          onClick={() => handlePageChange('finance')}
          active={currentPage == 'finance'}
        >
          Finance
        </Nav.Link>
      </Nav.Item>
      */}
      <Nav.Item>
        <Nav.Link 
          as={Link}
          to="/profile" 
          onClick={() => handlePageChange('profile')}
          active={currentPage == 'profile'}
        >
          Profile
        </Nav.Link>
      </Nav.Item>
      {/*
      <Nav.Item>
        <Nav.Link 
          as={Link}
          to="/settings" 
          onClick={() => handlePageChange('settings')}
          active={currentPage == 'settings'}
        >
          Settings
        </Nav.Link>
      </Nav.Item>
      */}
    </Nav>
  )
}